import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import useRouter from '@/composables/useRouter'
import WidgetBaseComponent from '@/components/widgets/WidgetBaseComponent.vue'
import LfWhiteCounterComponent from '@/components/counters/LfWhiteCounterComponent.vue'
import { Icons } from '@/icons/icons'
import { URLS } from '@/router/routes/urlRoutes'
import { ContextName } from '@/store/types/storeGlobalTypes'
import useSelectedRegister from '@/composables/useSelectedRegister'
import useStage from '@/composables/useStage'
import useGlobalVisionWidgets from '@/components/expedients/ExpedientCourts/composables/useGlobalVisionWidgets'

// INTERFACES
interface Resume {
  qty: number
  title: string
}

interface WidgetData {
  title: string
  actions: Resume[]
}

// CONSTS

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpedientActionsResumeWidget',
  setup(__props) {

const icons = {
  openWindow: Icons.OPEN_WINDOW
}

const contexts = {
  actionCounters: ContextName.EXPEDIENT_ACTIONS_RESUME_WIDGET,
  expedientContext: ContextName.EXPEDIENTS
}

// COMPOSABLES
const expedientRegister = useSelectedRegister({ entityName: contexts.expedientContext })
const { selectedRegisterId: selectedExpedientId } = expedientRegister

const { expedientStage } = useStage()
const { fetchExpedientLastActionsWidgetData } = useGlobalVisionWidgets()

// ROUTER
const { goToRoute } = useRouter()

// DATA
const widgetRef = ref(null)

const widgetData = ref<WidgetData>({
  title: '',
  actions: []
})

const showSpinner = ref(true)

// COMPUTED
const expedientStageState = computed(() => expedientStage.value)

const allDataLoaded = computed(() => {
  return !!widgetData.value.title
})

// METHODS
const fetchActionCounters = async () => {
  showSpinner.value = true

  widgetData.value = await fetchExpedientLastActionsWidgetData({
    selectedExpedientId: selectedExpedientId.value,
    filter: {
      source: contexts.actionCounters,
      idStage: expedientStageState.value
    }
  })

  showSpinner.value = false
}

const goToActionList = () => {
  goToRoute({
    name: URLS.ACTION_ALL
  })
}

// WATCHERS
watch(expedientStageState, () => {
  fetchActionCounters()
})

// INIT
fetchActionCounters()

return { __sfc: true,icons, contexts, expedientRegister, selectedExpedientId, expedientStage, fetchExpedientLastActionsWidgetData, goToRoute, widgetRef, widgetData, showSpinner, expedientStageState, allDataLoaded, fetchActionCounters, goToActionList, WidgetBaseComponent, LfWhiteCounterComponent }
}

})